module.exports = __webpack_public_path__ + "img/reserved.2f2f50fb.svg";